import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import apiAgent from "../../../app/api/apiAgent";
//import LoadingComponent from "../../../app/layout/LoadingComponent";
import { IntegrationsResponseModel } from "../../../app/models/IntegrationsResponseModel";
import { OfficeResponseModel } from "../../../app/models/OfficeResponseModel";
import { useStore } from "../../../app/stores/store";
import HeaderWrapper from "../../header/HeaderWrapper";
import { IntegrationGrid } from "./IntegrationGrid";
import OfficesGrid from "../Offices/OfficesGrid";
import AjaxLoader from "../../../app/common/common-components/AjaxLoader";
import Breadcrumb from "../../../app/common/common-components/Breadcrumb";

export default observer(function IntegrationsPage() {
  const [isLoading, setIsLoading] = useState(true);
  const [integration, setIntegration] = useState<IntegrationsResponseModel>();
  const {
    userStore: { userSession, logout, isLoggedIn },
  } = useStore();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search); // id=123
    let officeId: string = "";
    if (params.has("OfficeID")) {
      const id = params.get("OfficeID");
      officeId = id !== null ? id : "";
    }
    setIsLoading(true);
    apiAgent.Setting.getIntegrations(officeId)
      .then((response: IntegrationsResponseModel) => {
        let oIntegration: IntegrationsResponseModel = response;
        setIntegration(oIntegration);
        //console.log("integration", oIntegration);
      })
      .catch((error: any) => {
        console.log(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  document.title = "Base - Integrations";

  if (isLoading) {
    return <AjaxLoader />;
  } else if (!isLoading && integration) {
    return (
      <>
        <div className="integrations-page container-fluid">
          <Breadcrumb breadcrumbs={[{ text: "Home", path: "/" }, { text: "Settings", path: "/settings" }, { text: "Integrations" }]} />

          <div className="row">
            <div id="content" className="col-sm-12 col-md-12">
              <IntegrationGrid
                officeid={integration.officeID}
                officeDD={integration.officeDD}
                country={integration.country}
                super_admin={integration.super_admin}
              />
            </div>
          </div>
        </div>
      </>
    );
  } else {
    return <></>;
  }
});
